module.exports = __webpack_public_path__ + "img/5.a12762f9.png";